<template>
  <div id="kebai-login">
    <!-- <div class="page-login-bg">
      <div class="container">
        <div id="particles-js"></div>
        <canvas id="particles-js"></canvas>
      </div>
    </div> -->
    <div :class="`page-main-container ${loadImgState ? 'loadedImg' : ''}`">
      <img src="~@/assets/images/beijing.png" style="display: none" @load="imgLoading" />
      <div class="page-left-container">
        <!-- <div class="center-image">
          <img class="box-rotate" src="~@/assets/images/login-left-img.png" />
        </div> -->
        <div class="center-top">
          <div class="center-image">
            <img src="@/assets/images/logo-img.png" alt="" />
          </div>
          <!-- <div class="center-text">
            济南新旧动能转换起步区万亩国际粮食增产减损示范区智慧农业信物融合数字孪生综合管理系统
          </div> -->
        </div>
      </div>
      <div class="page-login-card">
        <div class="page-login-box">
          <div class="head">
            <div class="image">
              <!-- <img src="~@/assets/images/logo-img.png" alt="管理系统" /> -->
            </div>
            <div class="image-desc">登录</div>
          </div>
          <div class="input-content">账号</div>
          <div class="inputbox icon-middle">
            <input v-model="model.username" autocomplete="off" placeholder="请输入账号" class="username full" type="text" />
          </div>
          <div class="input-content">密码</div>
          <div class="inputbox icon-middle">
            <input v-model="model.password" autocomplete="off" placeholder="请输入密码" class="password full"
              type="password" />
          </div>
          <div class="input-content">验证码</div>
          <div class="inputbox icon-middle">
            <input v-model="model.code" autocomplete="off" placeholder="请输入验证码" class="code" style="width: 60%"
              type="text" />
            <img @click="newCodeImage" :src="codeImageUrl" style="
                cursor: pointer;
                width: 35%;
                height: 47px;
                margin-left: 20px;
                border-radius: 8px;
              " />
          </div>
          <div class="input-content"></div>
          <div class="btn-group help-button">
            <span class="inputbox rememberme">
              <label for="rememberme">
                <input type="checkbox" v-model="model.rmb" style="cursor: pointer" id="rememberme" />
                记住密码
              </label>
            </span>
            <span @click="clickForgetPassword" style="cursor: pointer" class="inputbox forget">忘记密码?</span>
          </div>

          <div class="inputbox" style="margin-top: 36px">
            <input @click="submitClick" class="button button-login submit full" value="登录" type="button" />
          </div>
          <!-- <div class="btn-group download">
            <span class="inputbox">
              <input
                name="android-download"
                @click="clickDownload(0)"
                :class="`button ${qrcodeStatus.qrcode0 ? 'active' : ''}`"
                type="button"
                value="Android下载"
              />
            </span>
            <span class="inputbox">
              <input
                name="ios-download"
                @click="clickDownload(1)"
                :class="`button ${qrcodeStatus.qrcode1 ? 'active' : ''}`"
                type="button"
                value="iOS下载"
              />
            </span>
          </div> -->
          <!-- <div class="qrcodebox">
            <span
              :class="`qrcode qrcode-0 ${qrcodeStatus.qrcode0 ? '' : 'hide'}`"
            >
              <img
                class="image"
                src="~@/assets/images/qr-code-android.png"
                alt="Android"
              />
            </span>
            <span
              :class="`qrcode qrcode-1 ${qrcodeStatus.qrcode1 ? '' : 'hide'}`"
            >
              <img
                class="image"
                src="~@/assets/images/qr-code-ios.png"
                alt="iOS"
              />
            </span>
          </div> -->
        </div>
      </div>
    </div>
    <transition enter-active-class="fadeInDown" leave-active-class="fadeOutUp" :duration="{ enter: 1000, leave: 1000 }">
      <div v-if="showMessage" :class="`dialog-forget-help ${showMessageType}`">
        <div class="help-text">{{ showMessage }}</div>
      </div>
    </transition>
    <div class="footer">
      <div class="footer-copyright-wrapper">
        <div class="copyright-list">
          <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备13033007号-3</a>
        </div>
        <span class="line"></span>
        <div class="copyright-list">
          <img src="@/assets/images/icp.png" alt="">
          <a href="https://beian.mps.gov.cn/#/query/websearch?code=11010802046678" rel="noreferrer"
            target="_blank">京公网安备11010802046678号</a>
        </div>
        <span class="line"></span>
        <div class="copyright-list">
          <span>©2018-2028 北京科百宏业科技有限公司 版权所有</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiRequest from "./api-login";
import background from "./background";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      apiReq: new ApiRequest(this),
      loadImgState: false,
      model: {
        captchaKey: new Date().getTime(),
        username: null,
        password: null,
        code: null,
        rmb: false,
        // Authorization: Base64.encode("modelwf:modelwf"),
        Authorization: Base64.encode("daping:daping"),
      },
      codeImageUrl: "",
      qrcodeStatus: {
        qrcode0: true,
        qrcode1: false,
      },
      showMessage: null, //请拨打客服电话:010-62127261
      showMessageType: 0,
    };
  },
  mounted() {
    // window.loading(false);
    // background();
    this.newCodeImage();

    setTimeout(() => {
      this.model.rmb = !!this.getStorage("rmbUser");
      if (this.model.rmb === true) {
        var username = this.getStorage("Username");
        var password = this.getStorage("Password");
        if (password && username) {
          this.model.username = username;
          this.model.password = Base64.decode(password);
        }
      } else {
        this.model.username = null;
        this.model.password = null;
      }
    }, 1000);

    document.onkeydown = (e) => {
      let event = e || window.event;
      let key = event.keyCode;
      if (key == 13) {
        this.submitClick();
      }
    };
  },
  methods: {
    imgLoading() {
      this.loadImgState = true;
    },
    submitClick() {
      if (
        this.model.username == null ||
        this.model.username.replace(/\s/g, "") == ""
      ) {
        this.showTips("请输入用户名", "warning");
        return;
      }
      if (
        this.model.password == null ||
        this.model.password.replace(/\s/g, "") == ""
      ) {
        this.showTips("请输入密码", "warning");
        return;
      }
      if (this.model.code == null || this.model.code.replace(/\s/g, "") == "") {
        this.showTips("请输入验证码", "warning");
        return;
      }
      let { username, password, code, captchaKey, Authorization } = this.model;
      this.doLogin({
        username,
        password,
        code,
        Authorization,
        key: captchaKey,
      });
    },
    doLogin(data) {
      // window.loading(true);
      localStorage.clear();
      this.apiReq
        .doLogin(data)
        .then((result) => {
          // window.loading(false);
          let data = result.data;
          this.$localStorage.set("expires_in", data.expires_in);
          this.$localStorage.set("access_token", data.access_token);
          this.$localStorage.set("refresh_token", data.refresh_token);

          this.setStorage("Username", this.model.username, 7);

          if (this.model.rmb === true) {
            this.setStorage("rmbUser", "true", 7);
            this.setStorage("Password", Base64.encode(this.model.password), 7);
            this.setStorage("userType", data.role, 7);
          } else {
            this.delStorage("userinfo");
            this.delStorage("rmbUser");
            this.delStorage("Password");
            this.setStorage("userType", data.role, 7);
          }
          //获取用户信息
          this.getUserInfo();
        })
        .catch((error) => {
          var msg = error.response.data;
          // window.loading(false);
          this.showTips(msg.message, "error");
          this.newCodeImage();
          console.log("服务端错误", error);
        });
    },
    getUserInfo() {
      this.apiReq.getUserInfo().then((data) => {
        console.log("用户信息", data);
        this.$localStorage.set("account", data);
        this.loadOrgData((orgMsg) => {
          this.$localStorage.set("organizationMsg", orgMsg);
          this.$localStorage.set("OPROrgMsg", orgMsg);
          if (data.roleId) {
            let roleList = data.roleId.split(",");
            let isadmin = roleList.some((item) => item == "1");
            let isYW = roleList.some((item) => item == "2");
            let isCrop = roleList.some((item) => item == "3");
            //admin
            if (isadmin) {
              window.location.href = "/febs/index.html";
              return;
            }
            //运维角色
            if (isYW) {
              window.location.href = "/febs/index.html";
              return;
            }
            //作物管理员直接跳转到作物模板管理。其他模快不需查看
            if (isCrop) {
              window.location.href = "/cloud/main.html";
              return;
            }
            if (orgMsg.orgType == 1) {
              if (orgMsg.ssoList.length != 0) {
                window.location.href = orgMsg.ssoList[0].path
                // let bigDataMsg = orgMsg.productList.find(
                //   (item) => item.code == "0200"
                // );
                // if (bigDataMsg) {
                //   window.location.href = "/bigdata/index.html";
                // } else {
                //   window.location.href = "/cloud/main.html";
                // }
              } else {
                window.location.href = "/cloud/main.html";
              }
            } else {
              window.location.href = "/bigdataProject/index.html";
            }
          } else {
            window.location.href = "/cloud/main.html";
          }
        });
      });
    },
    //获取当前登录用户绑定的机构信息
    loadOrgData(onok) {
      this.selectByOrganizationCode(onok);
    },
    //获取机构信息
    selectByOrganizationCode(onok) {
      this.apiReq
        .selectByOrganizationCode({
          organizationCode: this.$localStorage.get("account").organizationCode,
        })
        .then((res) => {
          if (res.code == 200) {
            onok(res.data);
          }
        });
    },
    delStorage(key) {
      this.$localStorage.remove(key);
    },
    getStorage(key) {
      return this.$localStorage.get(key);
    },
    setStorage(key, value, expire) {
      if (key && value) {
        this.$localStorage.set(key, value);
      }
    },
    newCodeImage() {
      this.model.code = null;
      this.apiReq
        .getCaptcha(this.model.captchaKey)
        .then((res) => {
          let base64 = btoa(
            new Uint8Array(res.data).reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, "")
          );
          return base64;
        })
        .then((res) => {
          this.codeImageUrl = "data:image/png;base64," + res;
        });
    },
    clickForgetPassword() {
      this.showTips("请拨打客服电话:010-62127261", "info");
    },
    showTips(msg, type) {
      this.$message({ type: type, message: msg });
    },
  },
};
</script>

<style lang="scss">
@import "./main.scss";

.inputbox {
  /deep/.el-checkbox__inner {
    background-color: rgba(0, 0, 0, 0.1);
    border: 1px solid #ffffff;
  }

  /deep/.el-checkbox__label {
    color: #ffffff;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: rgba(0, 0, 0, 0.1);
    border-color: #ffffff;
  }

  /deep/.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #ffffff;
  }
}
</style>
<style lang="scss" scoped>
#kebai-login {
  width: 100%;
  height: 100%;
  min-width: 1100px;

  position: relative;

  canvas {
    display: block;
  }

  #particles-js {
    width: 100%;
    height: 95%;
  }

  .page-main-container {
    width: 100%;
    height: 100%;
    background: url("~@/assets/images/beijingPre.png") no-repeat;
    background-size: 100% 100%;
  }

  .loadedImg {
    background: url("~@/assets/images/beijing.png") no-repeat;
    background-size: 100% 100%;
  }

  .footer {
    position: absolute;
    bottom: 21px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      text-decoration: none;
      background-color: transparent;
      color: #fff;
      font-size: 14px;
    }

    .footer-copyright-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      .copyright-list{
        line-height: 20px;
        display: flex;
        align-items: center;
        gap: 5px;
        img{
          width: 20px;
          height: 20px;
        }
      }
      span {
        font-size: 14px;
        color: #ffffff;
      }

      .line {
        width: 1px;
        height: 14px;
        background-color: #ffffff;
      }
    }
  }
}
</style>
